import script from "./HabitSample.vue?vue&type=script&setup=true&lang=js"
export * from "./HabitSample.vue?vue&type=script&setup=true&lang=js"

import "./HabitSample.vue?vue&type=style&index=0&id=15e06c56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15e06c56"]])

export default __exports__